import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addFaq, blockUnblockFaq, deleteFaq, editFaq, faqListing, viewFaq } from "../apis/apiHandler";

// List FAQs
export const allFaqs = createAsyncThunk(
    'faq/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await faqListing(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Add FAQ
export const addFaqs = createAsyncThunk(
    'faq/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await addFaq(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Edit FAQ
export const editFaqs = createAsyncThunk(
    'faq/edit',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await editFaq(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// View FAQ
export const viewFaqDetails = createAsyncThunk(
    'faq/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewFaq(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Delete FAQ
export const deleteFaqs = createAsyncThunk(
    'faq/delete',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await deleteFaq(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

// Toggle Status
export const changeFaqStatus = createAsyncThunk(
    'faq/status',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await blockUnblockFaq(payload);
            if (response?.code === 200) return response;
            else return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response?.data);
        }
    }
);

const initialState = {
    loading: false,
    faqList: [],
    faqDetail: {},
    error: null,
    addSuccess: false,
    editSuccess: false,
    deleteSuccess: false,
    statusSuccess: false
};

const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            // List
            .addCase(allFaqs.pending, (state) => {
                state.loading = true;
            })
            .addCase(allFaqs.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.faqList = payload?.data;
            })
            .addCase(allFaqs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Add
            .addCase(addFaqs.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
            })
            .addCase(addFaqs.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addFaqs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Edit
            .addCase(editFaqs.pending, (state) => {
                state.loading = true;
                state.editSuccess = false;
            })
            .addCase(editFaqs.fulfilled, (state) => {
                state.loading = false;
                state.editSuccess = true;
            })
            .addCase(editFaqs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // View
            .addCase(viewFaqDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(viewFaqDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.faqDetail = payload?.data;
            })
            .addCase(viewFaqDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Delete
            .addCase(deleteFaqs.pending, (state) => {
                state.loading = true;
                state.deleteSuccess = false;
            })
            .addCase(deleteFaqs.fulfilled, (state) => {
                state.loading = false;
                state.deleteSuccess = true;
            })
            .addCase(deleteFaqs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Status Toggle
            .addCase(changeFaqStatus.pending, (state) => {
                state.loading = true;
                state.statusSuccess = false;
            })
            .addCase(changeFaqStatus.fulfilled, (state) => {
                state.loading = false;
                state.statusSuccess = true;
            })
            .addCase(changeFaqStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default faqSlice.reducer;